import React, { useState, useEffect, lazy, Suspense, useCallback } from "react";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import AccessGateWrapper from "./Components/AccessGateWrapper";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./ComponentsCss/Nav.css";
import { FormProvider } from "./Components/FormProvider";
import { ScoreProvider } from "./Components/ScoreContext.jsx";
import NavigationBar from "./Components/Nav.jsx";
import logoGif from "./Assets/logo - Colored Background@2x.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { signOut, fetchAuthSession } from "@aws-amplify/auth";
/*****NEW TEST */
import { isTokenExpired, clearAllTokens, isTokenRevokedByCognito } from "./utils/tokenUtils";
// import { isTokenExpired, clearAllTokens } from "./utils/tokenUtils";

import AccessRequestPopup from "./Components/AccessRequestPopup.jsx";
import "./App.css";
import ActionPlan from "./Components/Actionplan.jsx";
import SecurityModel from "./Components/SecurityModel.jsx";
import IAM from "./Components/IAM.jsx";
import WirelessSecurity from "./Components/WirelessSecurity.jsx";
import ApplicationDatabaseSecurity from "./Components/Application&DatabaseSecurity.jsx";
import GenAI from "./Components/GenAI.jsx";
import BlockchainSecurity from "./Components/BlockChain.jsx";
import { getAuthConfig } from "./authConfig"; // Import dynamic region-based config
import Sponsor from "./Components/Sponsor.jsx";
import SiemIntegration from "./Components/SiemIntegration.jsx";
import AwsRegister from "./AwsRegister.jsx";
import PostLogin from "./Components/PostLogin.jsx";
import CCPAModule from "./Components/CCPA/CCPAModule.jsx";
import GDPRModule from "./Components/GDPR/GDPRModule.jsx";

import ViewDashboard from "./Components/ViewDashboard.jsx";
import PS21 from "./Components/PS21.jsx";
import ConnectM365 from "./Components/ConnectM365.jsx";
import ConnectIntruder from "./Components/ConnectIntruder.jsx";
import IncidentReporting from "./Components/Cyber Operational Resilience/UK/IncidentReporting.jsx";
import ThirdPartyInfrastructure from "./Components/Cyber Operational Resilience/UK/ThirdPartyInfrastructure.jsx";
import PECRCompliance from "./Components/Cyber Operational Resilience/UK/PECRCompliance.jsx";
import QuantumResilientSecurity from "./Components/Cyber Operational Resilience/UK/QuantumResilientSecurity.jsx";
import EncryptionICOReadiness from "./Components/Cyber Operational Resilience/UK/EncryptionICOReadiness.jsx";
import RegulatoryEngagement from "./Components/Cyber Operational Resilience/UK/RegulatoryEngagement.jsx";
import TelecomSecurityAct from "./Components/Cyber Operational Resilience/UK/TelecomSecurityAct.jsx";
import PCIDSSCompliance from "./Components/PCIDSSCompliance.jsx";
import NCSCCAF from "./Components/Cyber Operational Resilience/UK/NCSCCAF.jsx";
import PSNCompliance from "./Components/Cyber Operational Resilience/UK/PSNCompliance.jsx";
import InternalInvite from "./Components/InternalInvite.jsx";
import GlobalRiskOverview from "./Components/GlobalRiskOverview.jsx";
import { DomainUsersProvider } from './contexts/DomainUsersProvider';
import { RefreshProvider } from "./Components/RefreshContext.jsx";
import OTIoTSecurity from "./Components/OTIoTSecurity.jsx";
//import IEC62443NIST80082 from "./Components/IEC62443NIST80082.jsx";
import OperationalResilience from "./Components/OperationalResilience.jsx";
import AssetInventory from "./Components/AssetInventory.jsx";

import PrivateCloudHypervisor from "./Components/PrivateCloudHypervisor.jsx";
import NetworkSecurity from "./Components/Network Secuirty/NetworkSecurity.jsx";
import Cisco from "./Components/Network Secuirty/Cisco.jsx";
import Checkpoint from "./Components/Network Secuirty/Checkpoint.jsx";
import Fortinet from "./Components/Network Secuirty/Fortinet.jsx";
import PaloAlto from "./Components/Network Secuirty/PaloAlto.jsx";
import Juniper from "./Components/Network Secuirty/Juniper.jsx";
import DPDPInventoryTab from "./Components/India DPDP/DPDPInventoryTab.jsx";
import DPDPRetentionTab from "./Components/India DPDP/DPDPRetentionTab.jsx";
import DsarManagementTab from "./Components/India DPDP/DsarManagementTab.jsx";
import CrossBorderTransfersTab from "./Components/India DPDP/CrossBorderTransfersTab.jsx";
import PolicyGeneratorTab from "./Components/India DPDP/PolicyGeneratorTab.jsx";

import HIPAA from "./Components/Cyber Operational Resilience/US/HIPAA.jsx";
import RED from "./Components/RED.jsx";
import PDPL from "./Components/PDPL.jsx";
import EUAIActCompliance from "./Components/Cyber Operational Resilience/European Union (EU)/EUAIActCompliance.jsx";
import BS7858Security from "./Components/Cyber Operational Resilience/UK/BS7858Security.jsx";
import SecurityControls from "./Components/Overlapping Module/SecurityControls.jsx";
import PrivacyControls from "./Components/Overlapping Module/PrivacyControls.jsx";
import SOC2 from "./Components/SOC2/SOC2.jsx";
import NISTSP80053 from "./Components/NISTSP80053/NISTSP80053.jsx";
import NISTSP80063IAM from "./Components/NISTSP80063IAM/NISTSP80063IAM.jsx";
import NISTPrivacyFramework from "./Components/NIST Privacy Framework/NISTPrivacyFramework.jsx";
import CERTINSupplyChainGuidelines from "./Components/Supply Chain Risk/CERTINSupplyChainGuidelines.jsx";
import NCSCSupplyChainGuidelines from "./Components/Supply Chain Risk/NCSCSupplyChainGuidelines.jsx";
import NISTSP800161 from "./Components/Supply Chain Risk/NISTSP800161.jsx";
import { AuthProvider } from "./contexts/AuthContext";
import UAEModule from "./Components/UAE PDPL/UAEModule.jsx";
import CSCRFChecklist from "./Components/CSCRFChecklist/CSCRFChecklist.jsx";
import ManageUsers from "./Components/ManageUsers.jsx";
import SecurityEncryptionTab from "./Components/India DPDP/SecurityEncryptionTab.jsx";
import CyberEssentials from "./Components/CyberEssential.jsx";
import { NotificationProvider } from "./contexts/NotificationContext";
import SOXCompliance from "./Components/SOXCompliance.jsx";
import AvoidableLossCalculator from "./Components/AvoidableLossCalculator.jsx";
import SessionExpiredModal from "./Components/SessionExpiredModal";
import MITRE from "./Components/MITRE.jsx";
import COBIT from "./Components/COBIT.jsx";
import OWASP from "./Components/OWASP.jsx";
import ICFR from "./Components/ICFR.jsx";
import PhishingAssessmentModule from "./Components/Phishing Assessment/PhishingAssessmentModule.jsx";
import DPDPAssessmentModule from "./Components/DPDP Assessment/DPDPAssessmentModule.jsx";
import IAMOracle from "./Components/oracle cloud/IAMOracle.jsx";
import DataProtectionOracle from "./Components/oracle cloud/DataProtectionOracle.jsx";
import DetectionOracle from "./Components/oracle cloud/DetectionOracle.jsx";
import IncidentResponseOracle from "./Components/oracle cloud/IncidentResponseOracle.jsx";
import InfrastructureProtectionOracle from "./Components/oracle cloud/InfrastructureProtectionOracle.jsx";
import { ISOProvider } from "./contexts/ISOFileContext.js";
import ConnectTrendMicro from "./Components/ConnectTrendMicro.jsx";
import DastScanPage from "./Components/DastScanPage.jsx";
import SettingsPage from "./Components/pages/SettingsPage";
import UnifiedPrivacyModule from "./Components/India DPDP/UnifiedPrivacyModule.jsx";

import TrustDashboardPage from "./Components/pages/TrustDashboardPage.jsx";

// import CyberInsuranceAssessmentModule from "./Components/CyberInsurance Assessment Module/CyberInsuranceAssessmentModule.jsx";
// import SOC2AssessmentModule from "./Components/SOC2 Training/SOC2AssessmentModule.jsx";
// import RedactionPage from "./Components/RedactionPage.jsx";
// import TrustDashboardPage from "./Components/GT Module/TrustDashboardPage.jsx";
import TrustDomainPage from "./Components/pages/TrustDomainPage.jsx";
import TrustControlPage from "./Components/pages/TrustControlPage.jsx";
import AppSecAssessmentModule from "./Components/AppSecurityAssessment/AppSecAssessmentModule.jsx";
import PublicConsentPage from "./Components/ConsentManagement/PublicConsentPage";
import ConsentManagementModule from "./Components/ConsentManagement/ConsentManagementModule";
Amplify.configure(awsconfig);

// Lazy load components
const Overview = lazy(() => import("./Components/Overview.jsx"));
const Homepage = lazy(() => import("./Components/Homepage.jsx"));
const Detection = lazy(() => import("./Components/Detection.jsx"));
const Infrastructure = lazy(() => import("./Components/Infrastructure.jsx"));
const DataProtection = lazy(() => import("./Components/DataProtection.jsx"));
const InscidentResponse = lazy(
  () => import("./Components/InscidentResponse.jsx"),
);

const IAMAzure = lazy(() => import("./Components/AzureCloud/IAMAzure.jsx"));
const DetectionAzure = lazy(
  () => import("./Components/AzureCloud/DetectionAzure.jsx"),
);
const InfrastructureProtectionAzure = lazy(
  () => import("./Components/AzureCloud/InfrastructureProtectionAzure.jsx"),
);
const DataProtectionAzure = lazy(
  () => import("./Components/AzureCloud/DataProtectionAzure.jsx"),
);
const IncidentResponseAzure = lazy(
  () => import("./Components/AzureCloud/IncidentResponseAzure.jsx"),
);
const IAMGoogle = lazy(() => import("./Components/GoogleCloud/IAMGoogle.jsx"));
const DetectionGoogle = lazy(
  () => import("./Components/GoogleCloud/DetectionGoogle.jsx"),
);
const InfrastructureProtectiongoogle = lazy(
  () => import("./Components/GoogleCloud/InfrastructureProtectiongoogle.jsx"),
);
const DataProtectionGoogle = lazy(
  () => import("./Components/GoogleCloud/DataProtectionGoogle.jsx"),
);
const IRautomationGoogle = lazy(
  () => import("./Components/GoogleCloud/IRautomationGoogle.jsx"),
);

const DevSecOps = lazy(() => import("./Components/DevSecOps.jsx"));

const GroupPolicies = lazy(() => import("./Components/M365/GroupPolicies.jsx"));

const HybridConnect = lazy(() => import("./Components/M365/HybridConnect.jsx"));

const IAMandMFA = lazy(() => import("./Components/M365/IAMandMFA.jsx"));

const InTunesUserEnrollmentAndManagement = lazy(
  () => import("./Components/M365/InTunesUserEnrollmentAndManagement.jsx"),
);

const OnPremToCloudMigration = lazy(
  () => import("./Components/M365/OnPremToCloudMigration.jsx"),
);

const Sentinel = lazy(() => import("./Components/M365/Sentinel.jsx"));

const SSOAndEnterpriseApplications = lazy(
  () => import("./Components/M365/SSOAndEnterpriseApplications.jsx"),
);

const UserAdministration = lazy(
  () => import("./Components/M365/UserAdministration.jsx"),
);

const WindowsUserBitlockerencryption = lazy(
  () => import("./Components/M365/WindowsUserBitlockerencryption.jsx"),
);

const WindowsUserFirewallManagement = lazy(
  () => import("./Components/M365/WindowsUserFirewallManagement.jsx"),
);

const WindowsUserPatching = lazy(
  () => import("./Components/M365/WindowsUserPatching.jsx"),
);

const AnnexAControlsOverview = lazy(
  () =>
    import("./Components/ISO 27001 Compliance Checklist/AnnexAControlsOverview.jsx"),
);
const Organizational = lazy(
  () =>
    import("./Components/ISO 27001 Compliance Checklist/Organizational.jsx"),
);

const People = lazy(
  () => import("./Components/ISO 27001 Compliance Checklist/People.jsx"),
);

const Physical = lazy(
  () => import("./Components/ISO 27001 Compliance Checklist/Physical.jsx"),
);

const Technological = lazy(
  () => import("./Components/ISO 27001 Compliance Checklist/Technological.jsx"),
);

const DataAndRiskMgmt = lazy(
  () =>
    import("./Components/Privacy Data Protection Compliance Checklist/Data&RiskMgmt.jsx"),
);

const LegalCompliance = lazy(
  () =>
    import("./Components/Privacy Data Protection Compliance Checklist/LegalCompliance.jsx"),
);

const PrivacyEngineering = lazy(
  () =>
    import("./Components/Privacy Data Protection Compliance Checklist/PrivacyEngineering.jsx"),
);

const PrivacyFramework = lazy(
  () =>
    import("./Components/Privacy Data Protection Compliance Checklist/PrivacyFramework.jsx"),
);
const CRA = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/European Union (EU)/CRA.jsx"),
);

const DORA = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/European Union (EU)/DORA.jsx"),
);

const NIS2 = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/European Union (EU)/NIS2.jsx"),
);

const CSCRF = lazy(
  () => import("./Components/Cyber Operational Resilience/India/CSCRF.jsx"),
);

const NationalCyberSecurity = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/Ireland/NationalCyberSecurity.jsx"),
);

const CyberSecurityandResilience = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/UK/CyberSecurityandResilience.jsx"),
);

const GovAssureProgram = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/UK/GovAssureProgram.jsx"),
);

const CIRCIA = lazy(
  () => import("./Components/Cyber Operational Resilience/US/CIRCIA.jsx"),
);

const UpcomingExecutiveOrdersonAIandCybersecurity = lazy(
  () =>
    import("./Components/Cyber Operational Resilience/US/UpcomingExecutiveOrdersonAIandCybersecurity.jsx"),
);

const CISSecurity = lazy(() => import("./Components/CISSecurity.jsx"));

const TermsAndConditionsPopup = ({ onAccept }) => {
  const [isChecked, setIsChecked] = useState(false);

  // Check localStorage on mount
  useEffect(() => {
    if (localStorage.getItem("termsAccepted") === "true") {
      onAccept();
    }
  }, [onAccept]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleAccept = () => {
    if (isChecked) {
      onAccept();
      localStorage.setItem("termsAccepted", "true");
    } else {
      alert("You must accept the terms and conditions to proceed.");
    }
  };

  const handleSubmit = () => {
    handleAccept(); // Reuse accept logic
  };

  const handleCancel = () => {
    console.log("Terms popup cancelled");
  };
  return (
    <div
      className="TermsDiv container-fluid"
      role="dialog"
      aria-labelledby="terms-title"
      aria-modal="true"
    >
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10 col-11 Termdiv p-4">
          <div className="terms-header">
            <h2 id="terms-title" className="text-center mb-4">
              ServQual Unicorn Security Assessment Nexus (SUSAN)
              <br />
              Global Terms & Conditions
            </h2>
          </div>

          <div className="terms-content">
            <p className="welcome-text">
              Welcome to the{" "}
              <strong>
                ServQual Unicorn Security Assessment Nexus (SUSAN)
              </strong>
            </p>

            <div className="terms-section">
              <h3>1. Introduction & Scope</h3>
              <p>
                These Terms & Conditions govern access to and use of the
                ServQual Unicorn Security Assessment Nexus (SUSAN), including
                related websites, APIs, and support portals. SUSAN serves
                customers globally and applies regional privacy and security
                safeguards for various regions. Where local laws impose stricter
                requirements, ServQual will implement region-specific agendas
                that prevail over any conflicting general terms.
              </p>
            </div>

            <div className="terms-section">
              <h3>2. Assessment Basis</h3>
              <p>
                The assessment outcome is solely derived from the information
                provided by the user. Access to assessment results is restricted
                to registered customers under their respective accounts, unless
                the customer explicitly shares details with the ServQual team
                for business support.
              </p>
            </div>

            <div className="terms-section">
              <h3>3. Data Collection & Use</h3>
              <p>
                As part of this exercise, certain infrastructure details and
                customer inputs may be collected to assess your cybersecurity
                posture.
              </p>
              <ul>
                <li>
                  SUSAN leverages AI and automation using Anthropic Claude
                  foundation models to generate cybersecurity and compliance
                  insights.
                </li>
                <li>
                  ServQual applies responsible AI use guardrails and does not
                  use customer data to train, retrain, or improve any AI models.
                </li>
                <li>
                  Customer data is stored in the AWS region of initial
                  registration, in line with regional data residency
                  commitments.
                </li>
                <li>All data is encrypted at rest using AES-256 standards.</li>
                <li>
                  Login credentials and personal information are never shared
                  outside ServQual.
                </li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>4. Customer Data, Content & Ownership</h3>
              <p>
                <strong>Customer Data:</strong> All inputs, files, and data
                uploaded to SUSAN remain the sole property of the customer.
              </p>
              <p>
                <strong>Customer Content:</strong> AI-generated outputs are
                treated as customer content; neither ServQual nor its AI
                suppliers claim ownership.
              </p>
              <ul>
                <li>
                  Machine learning may produce similar or identical outputs
                  across customers.
                </li>
                <li>
                  Customers are responsible for ensuring their Customer Data and
                  use of outputs comply with applicable laws and do not infringe
                  third-party rights.
                </li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>5. Intellectual Property Indemnity</h3>
              <p>
                ServQual, backed by AWS Service Terms Section 50.10, will defend
                and indemnify Customers against third-party claims alleging that
                generative AI outputs from AWS indemnified services infringe
                copyright.
              </p>
              <p>
                This indemnity does not apply to claims arising from Customer
                Data, outputs derived from Customer Data, misuse of SUSAN, or
                use of services or models not covered by AWS indemnity.
                Customers remain responsible for legal review and risk
                management of AI outputs, consistent with AWS Responsible AI
                guidance.
              </p>
              <p>
                The Customer agrees to promptly notify ServQual of any
                infringement claim and cooperate reasonably in the defense.
              </p>
            </div>

            <div className="terms-section">
              <h3>6. AI & Data Assurance</h3>
              <p>
                ServQual applies pseudonymization, audit logging, and recommends
                human-in-the-loop validation to enhance trust, fairness, and
                accuracy of AI-driven outputs.
              </p>
              <p>
                For further details, users are encouraged to review the{" "}
                <strong>ServQual AI & Data Assurance Policy</strong> and the{" "}
                <strong>ServQual Privacy & Security Assurance Policy</strong>.
              </p>
              <p>
                <strong>Important:</strong> AI-generated output does not
                constitute legal, regulatory, financial, or professional advice
                and must be independently validated prior to use.
              </p>
            </div>

            <div className="terms-section">
              <h3>7. Regional Data Protection & Privacy Law Compliance</h3>
              <p>
                ServQual complies with all applicable data protection and
                privacy laws in every jurisdiction where it operates.
              </p>
              <ul>
                <li>
                  We ensure that appropriate consent is obtained for the
                  processing of personal data, including any additional
                  requirements for children's data, in accordance with local
                  regulations.
                </li>
                <li>
                  For international data transfers, ServQual implements lawful
                  and recognized mechanisms to maintain adequate safeguards and
                  protect data integrity.
                </li>
                <li>
                  In the event of a personal data breach, ServQual will notify
                  customers and, where required, competent authorities promptly
                  and in accordance with the timelines and procedures prescribed
                  by applicable laws.
                </li>
                <li>
                  Where legally required, the Customer remains responsible for
                  notifying affected data subjects and regulators based on their
                  role as data controller.
                </li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>8. Governing Law</h3>
              <p>
                These Terms shall be interpreted and enforced in accordance with
                applicable mandatory laws, without limiting the application of
                local laws that cannot be contractually excluded.
              </p>
            </div>

            <div className="terms-section">
              <h3>9. Cookies & Sessions</h3>
              <p>
                ServQual uses cookies to maintain session continuity and
                security. Region-specific cookies and consent requirements are
                implemented where applicable.
              </p>
            </div>

            <div className="terms-section">
              <h3>10. Personal Information & Contact Data</h3>
              <p>
                By registering with a corporate email address, ServQual will
                process limited personal information (name, email, phone) solely
                to provide business services, subject to data minimization and
                regional residency commitments.
              </p>
              <p>
                ServQual shall not be responsible for compliance failures
                arising from inaccurate or obscured regional information caused
                by VPN usage or location masking.
              </p>
            </div>

            <div className="terms-section">
              <h3>11. Access, Charges & Support</h3>
              <p>
                ServQual reserves the right to manage access to SUSAN for
                support or security reasons. If you request support by clicking
                "Get Help," you may be asked for details for business support
                purposes.
              </p>
            </div>

            <div className="terms-section">
              <h3>12. Acceptable Use & Export Controls</h3>
              <p>
                Customers must not use SUSAN to violate applicable laws
                (including sanctions and export controls), to generate unlawful
                content, or to circumvent platform guardrails. AWS Responsible
                AI policy expectations apply when AWS services are used.
              </p>
            </div>

            <div className="terms-section">
              <h3>13. Disclaimers & Liability</h3>
              <p>
                SUSAN's guidance is for information only—cybersecurity risk
                decisions remain the customer's responsibility. The list is not
                exhaustive. Users are advised to seek certified cybersecurity
                expertise for full evaluations.
              </p>
              <p>
                The Customer acknowledges that assessments do not constitute
                legal, regulatory, or professional advice and must not be relied
                upon as the sole basis for security, compliance, or risk
                decisions. SUSAN does not guarantee eligibility for or outcomes
                of cyber insurance underwriting or claims.
              </p>
            </div>

            <div className="terms-section">
              <h3>14. Termination, Suspension & Data Handling</h3>
              <p>
                ServQual may suspend or terminate access for material breach,
                security risk, or unlawful use, with notice where feasible.
              </p>
              <p>
                <strong>Post-Termination:</strong> Customer may request deletion
                of Customer Data and content from operational systems, subject
                to legal retention and audit obligations.
              </p>
            </div>

            <div className="terms-section">
              <h3>15. Amendments & Updates</h3>
              <p>
                ServQual reserves the right to amend or update these Terms &
                Conditions. Any changes will not affect the Customer's current
                subscription or agreement term.
              </p>
              <p>
                Updated Terms & Conditions will only take effect on the renewal
                of the Customer's agreement or upon the commencement of a new
                subscription period. Customers will be notified in advance of
                material changes, and continued use of the SUSAN platform after
                renewal will constitute acceptance of the updated Terms &
                Conditions.
              </p>
            </div>

            <div className="terms-section">
              <h3>16. Warranty Disclaimer and Advisory Nature of Outputs</h3>
              <p>
                SUSAN provides advisory guidance, risk scoring, compliance
                mappings, insights, recommendations, and related materials for
                informational purposes only.
              </p>
              <p>
                ServQual does not warrant or guarantee that the use of SUSAN
                will achieve any specific outcomes, including but not limited to
                audit readiness, certification, cyber insurance eligibility,
                regulatory compliance, risk mitigation, breach prevention, or
                business continuity. All decisions made based on outputs
                provided by SUSAN remain solely the responsibility of the
                Customer.
              </p>
              <p>
                SUSAN and any contained materials or features are provided on an{" "}
                <strong>"as is"</strong> and <strong>"as available"</strong>{" "}
                basis. ServQual disclaims all warranties, whether express,
                implied, statutory, or otherwise, including any warranties of
                accuracy, completeness, performance, merchantability, fitness
                for a particular purpose, and non-infringement.
              </p>
            </div>

            <div className="terms-section">
              <h3>17. Limitation of Liability</h3>
              <p>
                To the maximum extent permitted by law, ServQual excludes all
                liability for indirect, incidental, special, punitive,
                exemplary, or consequential losses or damages, including:
              </p>
              <ul>
                <li>Loss of profits, revenue, business, data, or goodwill</li>
                <li>Business interruption</li>
                <li>Compliance failures or regulatory fines</li>
                <li>Cyber insurance claim decisions</li>
                <li>Certification outcomes or audit results</li>
              </ul>
              <p>
                ServQual's aggregate liability arising out of or relating to the
                use of SUSAN shall not exceed the total fees paid by the
                Customer for the twelve (12) months preceding the event giving
                rise to liability.
              </p>
              <p>
                Where SUSAN is provided free of charge or on a trial basis,
                ServQual shall have no liability to the Customer except for
                liability that cannot be excluded under applicable law.
              </p>
              <p>
                <strong>
                  Nothing in these Terms shall exclude liability for fraud or
                  for any liability which cannot be excluded by law.
                </strong>
              </p>
            </div>

            <div className="terms-section">
              <h3>18. Customer Indemnity</h3>
              <p>
                The Customer shall indemnify and hold harmless ServQual from and
                against all claims, damages, losses, liabilities, penalties,
                regulatory actions, and expenses (including reasonable legal
                fees) arising out of or relating to:
              </p>
              <ul>
                <li>
                  Customer Data or Customer uploads, submissions, or
                  integrations
                </li>
                <li>Customer breach of these Terms</li>
                <li>Customer misuse of SUSAN or use contrary to law</li>
                <li>
                  Customer violations of privacy, data protection, or export
                  laws
                </li>
                <li>
                  Any third-party claims arising from Customer sharing,
                  publication, or reliance on outputs outside SUSAN
                </li>
                <li>
                  Audit, certification, regulatory, compliance, or insurance
                  actions based on Customer reliance upon outputs
                </li>
                <li>
                  Any infringement of third-party IP or contractual rights
                  arising from Customer use or distribution of SUSAN outputs
                </li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>19. Export Controls, Sanctions, and Restricted Use</h3>
              <p>
                Customer represents and warrants that they are not located in,
                resident in, or accessing SUSAN from jurisdictions subject to
                sanctions, embargoes, or trade restrictions under applicable
                laws.
              </p>
              <p>
                Customer shall comply with all export control and sanctions
                laws, including those administered by the United States, United
                Kingdom, European Union, and the United Nations.
              </p>
              <p>
                Customer must not use SUSAN for purposes prohibited by
                applicable export control laws or to support operations in
                restricted jurisdictions.
              </p>
            </div>

            <div className="terms-section">
              <h3>20. Multi-Tenant Architecture</h3>
              <p>
                SUSAN operates as a multi-tenant software-as-a-service platform.
                Customer Data is logically segregated through software controls.
              </p>
              <p>
                Customers acknowledge that SUSAN does not provide dedicated
                physical or single-tenant environments unless expressly
                contracted in writing.
              </p>
            </div>

            <div className="terms-section">
              <h3>21. Licensing and Usage Restrictions</h3>
              <p>
                Subject to the Customer's continued compliance with these Terms,
                ServQual grants a limited, non-exclusive, non-transferable,
                non-sublicensable license to access and use SUSAN for internal
                business purposes only.
              </p>
              <p>
                Customer must not copy, distribute, sublicense, resell, rent,
                lease, modify, adapt, translate, reverse engineer, decompile,
                disassemble, benchmark, or create derivative works based on
                SUSAN except where permitted by law.
              </p>
              <p>
                Customer shall not use SUSAN or its outputs to train, fine-tune,
                benchmark, or improve any artificial intelligence or machine
                learning models.
              </p>
            </div>

            <div className="terms-section">
              <h3>22. Benchmarking and Publication Restrictions</h3>
              <p>
                Customer shall not publicly disclose or publish any
                benchmarking, performance testing, competitive analysis, product
                evaluation, or similar assessments of SUSAN without prior
                written approval from ServQual.
              </p>
            </div>

            <div className="terms-section">
              <h3>23. Feedback and Suggestions</h3>
              <p>
                Any suggestions, feedback, recommendations, ideas, feature
                requests, enhancements, or improvements provided by the Customer
                shall not be considered confidential and Customer grants
                ServQual a perpetual, irrevocable, royalty-free right to use
                feedback without restriction.
              </p>
            </div>

            <div className="terms-section">
              <h3>24. Third-Party Integrations and APIs</h3>
              <p>
                SUSAN may support integrations with third-party systems, APIs,
                cloud services, cybersecurity platforms, SIEM tools, telemetry
                feeds, audit systems, and similar services.
              </p>
              <p>
                ServQual does not control and is not responsible for the
                performance, availability, stability, or security of third-party
                integrations. Customer acknowledges that changes to third-party
                services may affect the functionality of such integrations.
              </p>
              <p>
                Customer remains responsible for any credentials, permissions,
                and API keys used for integrations.
              </p>
            </div>

            <div className="terms-section">
              <h3>25. Support, Maintenance, and Availability</h3>
              <p>
                ServQual shall use commercially reasonable efforts to maintain
                availability of SUSAN. ServQual may conduct maintenance,
                upgrades, or emergency interventions without liability.
              </p>
              <p>
                No guaranteed service level applies unless expressly included in
                a separate written SLA. Support response times, availability,
                and service windows may vary by region and subscription tier.
              </p>
              <p>
                Availability may be impacted by events beyond ServQual's
                reasonable control.
              </p>
            </div>

            <div className="terms-section">
              <h3>26. Data Retention, Deletion, and Backups</h3>
              <p>
                ServQual shall retain Customer Data for the duration of the
                subscription and for a reasonable period thereafter for backup,
                legal, business continuity, and audit purposes.
              </p>
              <p>
                Upon termination or expiry, Customers may request deletion of
                Customer Data from operational systems, subject to legal,
                compliance, archival, or regulatory retention obligations.
              </p>
              <p>
                Disaster recovery mechanisms may retain encrypted backups for
                administrative purposes.
              </p>
            </div>

            <div className="terms-section">
              <h3>27. Audit, Compliance, and Insurance Use</h3>
              <p>
                SUSAN may support audit preparation, compliance management,
                privacy obligations, cyber insurance questionnaires, and
                governance exercises.
              </p>
              <p>
                ServQual does not act as the Customer's legal adviser, auditor,
                DPO, CISO, or regulatory authority. Certification, approval,
                underwriting, risk scoring, audit acceptance, and compliance
                determinations remain solely the responsibility of the Customer
                and applicable third parties.
              </p>
            </div>

            <div className="terms-section">
              <h3>28. Acceptance</h3>
              <p>
                By clicking <strong>"I Agree"</strong>, the user confirms
                acceptance of these Terms & Conditions.
              </p>
              <p>
                The ServQual Privacy Policy and ServQual AI & Data Assurance
                policies are provided for transparency and informational
                purposes only.
              </p>
              <p>
                Marketing communications, where applicable, are strictly{" "}
                <strong>optional (opt-in)</strong> and may be withdrawn at any
                time.
              </p>
            </div>
          </div>

          <div className="form-check mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              id="acceptTerms"
              checked={isChecked}
              onChange={handleCheckboxChange}
              style={{
                border: "1px solid black",
                cursor: "pointer",
                accentColor: "black",
                transform: "scale(1.2)",
              }}
            />
            <label className="form-check-label" htmlFor="acceptTerms">
              I accept the terms and conditions
            </label>
          </div>

          <div className="terms-footer mt-4">
            <button
              className="btn btn-primary me-2"
              onClick={handleSubmit}
              disabled={!isChecked}
            >
              I Agree
            </button>
            <button
              className="btn btn-secondary"
              onClick={handleCancel} // ✅ FIXED: Proper cancel handler
            >
              Cancel
            </button>
            <p className="text-center text-muted mt-3">
              Last Updated: January 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const App = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showAnimation, setShowAnimation] = useState(true);
  const [authConfig, setAuthConfig] = useState(null);
  const [showSessionExpired, setShowSessionExpired] = useState(false);

  // ⬇️ ADDED: access gate state
  const [accessStatus, setAccessStatus] = useState("unknown");
  const [showAccessPopup, setShowAccessPopup] = useState(false);

  const [showTerms, setShowTerms] = useState(() => {
    return localStorage.getItem("termsAccepted") !== "true"; // Only show terms if not accepted
  });
const isPublicConsentLink = () => {
  return window.location.pathname.startsWith("/consent/");
};
  useEffect(() => {
    // ✅ Enhanced redirect logic for all new/unauthenticated users
    const currentUrl = window.location.href;
    // if (window.location.pathname.startsWith("/consent/")) return;
    const hasAuthToken =
      currentUrl.includes("id_token") ||
      currentUrl.includes("code") ||
      currentUrl.includes("access_token");

    // Check multiple authentication indicators
    const storedIdToken = sessionStorage.getItem("idToken");
    const localIdToken = localStorage.getItem("idToken");
    const termsAccepted = localStorage.getItem("termsAccepted");

    // If this is NOT a Cognito callback AND user has no valid authentication
    if (!hasAuthToken) {
      const isAuthenticated = storedIdToken && !isTokenExpired(storedIdToken);

      // Redirect to static login page if:
      // 1. No valid stored tokens OR
      // 2. User hasn't accepted terms (indicating new user)
      const isConsentLink = window.location.pathname.startsWith("/consent/");
    
      if ( isConsentLink) return;
      if (!isAuthenticated || !termsAccepted) {
        console.log("Redirecting unauthenticated user to static login page");
        window.location.href = "https://scpauth.servqualit.com/";
        return;
      }
    }
  }, []);

  useEffect(() => {
    const configureAuth = async () => {
      try {
        const config = await getAuthConfig();
        setAuthConfig(config);
        Amplify.configure(config);
      } catch (error) {
        // handle error if needed
      }
    };

    configureAuth();
  }, []);

  const handleSignIn = useCallback(() => {
    if (!authConfig) return;

    const signInUrl = `${authConfig.oauth.domain}/signup?client_id=${authConfig.aws_user_pools_web_client_id
      }&response_type=token&scope=email+openid+phone+profile&redirect_uri=${encodeURIComponent(
        authConfig.oauth.redirectSignIn,
      )}`;

    window.location.href = signInUrl;
  }, [authConfig]);

  // 3. MEMOIZE handleSignOut - MOVE THIS UP
  const handleSignOut = useCallback(() => {
    if (!authConfig) return;

    console.log("Signing out user...");
    clearAllTokens();
    setUser(null);

    signOut()
      .then(() => {
        const signOutUrl = `${authConfig.oauth.domain}/logout?client_id=${authConfig.aws_user_pools_web_client_id}&logout_uri=${authConfig.oauth.redirectSignOut}`;
        window.location.href = signOutUrl;
      })
      .catch((error) => {
        console.error("Sign out error:", error);

        const signOutUrl = `${authConfig.oauth.domain}/logout?client_id=${authConfig.aws_user_pools_web_client_id}&logout_uri=${authConfig.oauth.redirectSignOut}`;
        window.location.href = signOutUrl;
      });
  }, [authConfig]);

  const handleSessionExpiredSignIn = () => {
    clearAllTokens();
    window.location.href = "https://ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com/logout?client_id=689baoimsmi285997eflt8hdqa&logout_uri=https://demo.securecloud.tech&response_type=token&scope=email+openid+phone+profile";
  };

  const checkUserSession = useCallback(async () => {
    if (isPublicConsentLink()) {
  setIsLoading(false);
  return;
}
    const storedIdToken = sessionStorage.getItem("idToken");

    if (storedIdToken) {
      if (isTokenExpired(storedIdToken)) {
        console.log("Stored token is expired, attempting refresh...");
        clearAllTokens();
        setShowSessionExpired(true); // Show modal instead of auto-redirect
        return;

        // (refresh code below is unreachable because of return, kept as-is)
        try {
          const session = await fetchAuthSession({
            forceRefresh: true,
          });

          if (session?.idToken && !isTokenExpired(session.idToken.jwtToken)) {
            setUser(session.idToken.payload);
            sessionStorage.setItem("idToken", session.idToken.jwtToken);
            console.log("Token refreshed successfully");
          } else {
            console.log("Cannot get valid token, redirecting to login");
            handleSignIn();
          }
        } catch (err) {
          console.error("Token refresh failed:", err);
          handleSignIn();
        }
      } else {
        try {
          const userData = JSON.parse(atob(storedIdToken.split(".")[1]));
          setUser(userData);
        } catch (error) {
          console.error("Error decoding token:", error);
          handleSignIn();
        }
      }
    } else {
      try {
        const session = await fetchAuthSession();

        if (session?.idToken && !isTokenExpired(session.idToken.jwtToken)) {
          setUser(session.idToken.payload);
          sessionStorage.setItem("idToken", session.idToken.jwtToken);
        } else {
          handleSignIn();
        }
      } catch (err) {
        console.error("Session check failed:", err);
        handleSignIn();
      }
    }

    setIsLoading(false);
  }, [handleSignIn]);

  const getAwsCustomerId = () => {
    return (
      localStorage.getItem("aws_customer_id") ||
      sessionStorage.getItem("aws_customer_id") ||
      null
    );
  };

  // ADD THIS in the second useEffect where you handle URL tokens:
  useEffect(() => {
    if (!authConfig) return;
 if (window.location.pathname.startsWith("/consent/")) {
      setIsLoading(false);
      return;
    }
    const urlParams = new URLSearchParams(window.location.hash.substr(1));
    const idToken = urlParams.get("id_token");
    const accessToken = urlParams.get("access_token");

    if (idToken && accessToken) {
      if (isTokenExpired(idToken)) {
        console.log("Token from URL is already expired");
        handleSignIn();
        return;
      }

      sessionStorage.setItem("idToken", idToken);
      sessionStorage.setItem("accessToken", accessToken);
      localStorage.setItem("idToken", idToken);

      try {
        const userData = JSON.parse(atob(idToken.split(".")[1]));
        setUser(userData);

        // === AWS Marketplace linkage ===
        const stateParam = new URLSearchParams(
          window.location.hash.substr(1),
        ).get("state");

        if (stateParam) {
          try {
            const decodedState = JSON.parse(decodeURIComponent(stateParam));

            console.log("AWS state received:", decodedState);

            if (
              decodedState.billingSource === "AWS" &&
              decodedState.awsCustomerId
            ) {
              localStorage.setItem("billing_source", "AWS");
              localStorage.setItem(
                "aws_customer_id",
                decodedState.awsCustomerId,
              );
              localStorage.setItem(
                "selectedRegion",
                decodedState.region || "GB",
              );

              // ✅ Call backend to link AWS customer → Cognito user
              fetch(
                "https://pr4haujdxj.execute-api.ap-southeast-2.amazonaws.com/prod/aws/link-customer",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    email: userData.email,
                    awsCustomerId: decodedState.awsCustomerId,
                  }),
                },
              )
                .then((r) => r.json())
                .then((res) => console.log("AWS customer linked:", res))
                .catch((err) => console.error("AWS link error:", err));
            }
          } catch (e) {
            console.error("Failed to parse AWS state:", e);
          }
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        handleSignIn();
      }

      setIsLoading(false);
    } else {
  if (isPublicConsentLink()) {
    setIsLoading(false);
    return;
  }

  checkUserSession();
}
  }, [authConfig, handleSignIn, checkUserSession]);

  // ⬇️ ADDED: orgId-based access status
  // const fetchAccessStatus = async (orgId) => {
  // try {
  // const regionCode =
  // sessionStorage.getItem("userRegion") || "GB";
  // const res = await fetch(
  // "https://wloxklsfz3.execute-api.eu-west-1.amazonaws.com/prod/api/prod/access-status",
  // {
  // method: "POST",
  // headers: { "Content-Type": "application/json" },
  // body: JSON.stringify({ orgId, regionCode }),
  // }
  // );
  // const data = await res.json();
  // { status: "approved" | "pending" | "none" }
  // setAccessStatus(data.status);
  // if (data.status === "pending" || data.status === "none") {
  // setShowAccessPopup(true);
  // }
  // } catch (e) {
  // console.error("Error fetching access status", e);
  // setAccessStatus("pending");
  // setShowAccessPopup(true);
  // }
  // };
  const fetchAccessStatus = async (orgId, regionFromCaller) => {
    try {
      const regionCode =
        regionFromCaller || sessionStorage.getItem("userRegion") || "AP";

      const res = await fetch(
        "https://g7xjcl7zp6.execute-api.ap-southeast-2.amazonaws.com/prod/api/prod/access-status",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },

          body: JSON.stringify({ orgId, regionCode }),
        },
      );

      if (!res.ok) {
        console.error("Access status API failed:", res.status);
        throw new Error(`API failed: ${res.status}`);
      }

      // const data = await res.json();
      // console.log("Access status response:", data);

      const data = await res.json();
      const status = data.status || "none"; // "none" | "pending" | "approved" | "rejected"

      console.log("Fetched status:", status);

      setAccessStatus(status);

      // Show popup for any non-approved state
      if (status !== "approved") {
        setShowAccessPopup(true);
      } else {
        setShowAccessPopup(false);
      }
    } catch (e) {
      console.error("Error fetching access status", e);
      setAccessStatus("pending");
      setShowAccessPopup(true);
    }
  };

  // Add this useEffect to check tokens when user returns to the page
  useEffect(() => {
    if (!user) return;

    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        const storedIdToken = sessionStorage.getItem("idToken");

        if (storedIdToken && isTokenExpired(storedIdToken)) {
          setShowSessionExpired(true); // Show modal

          console.log(
            "Token expired while page was hidden - attempting refresh",
          );

          try {
            const session = await fetchAuthSession({
              forceRefresh: true,
            });

            if (session?.idToken && !isTokenExpired(session.idToken.jwtToken)) {
              sessionStorage.setItem("idToken", session.idToken.jwtToken);
              setUser(session.idToken.payload);

              console.log("Token refreshed successfully");
            } else {
              console.log(
                "Token refresh failed - user needs to manually log out",
              );
              // Don't auto sign-out - let user continue with expired session
            }
          } catch (error) {
            console.error("Token refresh error:", error);
            // Don't auto sign-out - let user continue with expired session
          }
        }
        /***NEW TEST */
        const revoked = await isTokenRevokedByCognito();
        if (revoked) {
          console.log("🔴 Token revoked on tab focus. Signing out...");
          clearAllTokens();
          setUser(null);
          window.location.href = "https://ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com/logout?client_id=689baoimsmi285997eflt8hdqa&logout_uri=https://demo.securecloud.tech&response_type=token&scope=email+openid+phone+profile";
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [user]);

  // Add this useEffect to set up API error handling
  useEffect(() => {
    if (!authConfig || !user) return;

    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      if (response.status === 401) {
        console.log("API returned 401 - token may be expired");

        const storedIdToken = sessionStorage.getItem("idToken");

        if (!storedIdToken || isTokenExpired(storedIdToken)) {
          console.log("Token expired - API calls may fail until manual logout");
          // Don't auto sign-out - let user decide when to log out
        }
      }

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, [authConfig, user]);

  useEffect(() => {
    if (!user || !authConfig) return;

    const validateTokenPeriodically = async () => {
      const storedIdToken = sessionStorage.getItem("idToken");

      if (storedIdToken && isTokenExpired(storedIdToken)) {
        setShowSessionExpired(true);

        console.log("Token expired during periodic check - attempting refresh");

        try {
          const session = await fetchAuthSession({
            forceRefresh: true,
          });

          if (session?.idToken && !isTokenExpired(session.idToken.jwtToken)) {
            sessionStorage.setItem("idToken", session.idToken.jwtToken);
            setUser(session.idToken.payload);

            console.log("Token refreshed successfully via periodic check");
          } else {
            console.log(
              "Cannot refresh expired token - user should manually log out",
            );
            // Don't auto sign-out - let user continue with expired session
          }
        } catch (error) {
          console.error("Periodic token refresh failed:", error);
          // Don't auto sign-out - let user continue with expired session
        }
      }
    };

    const interval = setInterval(validateTokenPeriodically, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, [user, authConfig]);

  /******Revocation Polling TEST NEW ONE ADDED */
  // ADD THIS in App.js — after the periodic token validation useEffect

  useEffect(() => {
    if (!user || !authConfig) return;

    const checkIfAdminSignedOutUser = async () => {
      const revoked = await isTokenRevokedByCognito();
      if (revoked) {
        console.log("🔴 Admin signed out this user. Redirecting to login...");
        clearAllTokens();
        setUser(null);
        // Redirect to your login page
        window.location.href = "https://ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com/logout?client_id=689baoimsmi285997eflt8hdqa&logout_uri=https://demo.securecloud.tech&response_type=token&scope=email+openid+phone+profile";
      }
    };

    // Check every 60 seconds — adjust to your preference
    const interval = setInterval(checkIfAdminSignedOutUser, 30 * 1000);

    return () => clearInterval(interval);
  }, [user, authConfig]);


  // ── Activity Log Interceptor — fires once user is authenticated ──
  // Activity Log Interceptor — orgId extracted from localStorage key pattern


  useEffect(() => {
    if (showAnimation) {
      setTimeout(() => {
        setShowAnimation(false);
      }, 3000);
    }
  }, [showAnimation]);

  const handleAcceptTerms = () => {
    setShowTerms(false);
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <img src={logoGif} alt="Loading..." className="logo-animation" />
      </div>
    );
  }
if (isPublicConsentLink()) {
  return (
    <Router>
      <Routes>
        <Route path="/consent/:token" element={<PublicConsentPage />} />
      </Routes>
    </Router>
  );
}

  const isApproved = accessStatus === "approved";
  const isLoadingAccess = accessStatus === "unknown";



  return (
    <>
      {showSessionExpired && (
        <SessionExpiredModal onSignIn={handleSessionExpiredSignIn} />
      )}

      <div className="desktop-message-popup">
        <div className="popup-content">
          <p>
            📢 Best Viewed on Desktop <br />
            For the optimal experience, please visit on your laptop or desktop.
          </p>
        </div>
      </div>

      <AuthProvider user={user} setUser={setUser} authConfig={authConfig}>
        <NotificationProvider>
          <FormProvider>
            <ScoreProvider userData={user}>
              <ISOProvider userData={user}>
                <RefreshProvider>
                  <DomainUsersProvider>
                    <AccessGateWrapper
                      user={user}
                      fetchAccessStatus={fetchAccessStatus}
                      accessStatus={accessStatus}
                      setAccessStatus={setAccessStatus}
                      showAccessPopup={showAccessPopup}
                      setShowAccessPopup={setShowAccessPopup}
                    >
                      <Router>
                        {showAnimation ? (
                          <div className="loading-screen">
                            <img
                              src={logoGif}
                              alt="Loading..."
                              className="logo-animation"
                            />
                          </div>
                        ) : (
                          <>

                            {user && showTerms && (
                              <TermsAndConditionsPopup
                                onAccept={handleAcceptTerms}
                              />
                            )}

                            <Suspense
                              fallback={
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: "100vh" }}
                                >
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                </div>
                              }
                            >
                              <Routes>
                                {/* ================= PUBLIC ROUTES ================= */}
                                <Route
                                  path="/post-login"
                                  element={<PostLogin />}
                                />
                                <Route
                                  path="/aws-register"
                                  element={<AwsRegister />}
                                />

                                <Route
                                  path="/consent/:token"
                                  element={<PublicConsentPage />}
                                />


                                {/* ================= NOT LOGGED IN ================= */}
                                {/* {!user && (
                                <Route
                                  path="*"
                                  element={
                                    <div className="loading-screen">
                                      <img
                                        src={logoGif}
                                        alt="Loading..."
                                        className="logo-animation"
                                      />
                                    </div>
                                  }
                                />
                              )} */}

                                {/* ================= LOGGED IN BUT NOT APPROVED ================= */}
                                {user && !isApproved && (
                                  <Route
                                    path="*"
                                    element={
                                      <div
                                        style={{
                                          textAlign: "center",
                                          marginTop: "50px",
                                        }}
                                      >
                                        <h3>Waiting for approval...</h3>
                                      </div>
                                    }
                                  />
                                )}

                                {/* ================= APPROVED USER ROUTES ================= */}
                                {/* {user && isApproved && ( */}
                                {user ? (
                                  <>
                                    <Route
                                      path="/"
                                      element={<SecurityModel userData={user} />}
                                    />
                                    <Route
                                      path="/phishingassessment"
                                      element={
                                        <PhishingAssessmentModule
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/dpdp-assessment"
                                      element={
                                        <DPDPAssessmentModule userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/appsec-assessment"
                                      element={
                                        <AppSecAssessmentModule userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/securitycontrols"
                                      element={
                                        <SecurityControls userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/privacycontrols"
                                      element={
                                        <PrivacyControls userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/settings"
                                      element={<SettingsPage userData={user} />}
                                    />
                                    <Route path="/trust" element={<TrustDashboardPage userData={user} />} />
                                    <Route path="/trust/domain/:domainId" element={<TrustDomainPage userData={user} />} />
                                    <Route path="/trust/control/:controlId" element={<TrustControlPage userData={user} />} />
                                    <Route
                                      path="/assetinventory"
                                      element={<AssetInventory userData={user} />}
                                    />
                                    <Route
                                      path="/dpdpmodule"
                                      element={<UnifiedPrivacyModule userData={user} />}
                                    />


                                    {/* ✅ ADDED */}
                                    <Route
                                      path="/ccpamodule"
                                      element={<CCPAModule userData={user} />}
                                    />

                                    <Route
                                      path="/gdpr"
                                      element={<GDPRModule userData={user} />}
                                    />
                                    <Route
                                      path="/uaemodule"
                                      element={<UAEModule userData={user} />}
                                    />
                                    <Route
                                      path="/pdpl"
                                      element={<PDPL userData={user} />}
                                    />
                                    <Route
                                      path="/data&riskmgmt"
                                      element={
                                        <DataAndRiskMgmt userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/legalCompliance"
                                      element={
                                        <LegalCompliance userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/privacyengineering"
                                      element={
                                        <PrivacyEngineering userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/privacymaturity"
                                      element={
                                        <PrivacyFramework userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/nistprivacyframework"
                                      element={
                                        <NISTPrivacyFramework userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/nist"
                                      element={<NISTSP800161 userData={user} />}
                                    />
                                    <Route
                                      path="/ncsc"
                                      element={
                                        <NCSCSupplyChainGuidelines
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/certin"
                                      element={
                                        <CERTINSupplyChainGuidelines
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/nis2"
                                      element={<NIS2 userData={user} />}
                                    />
                                    <Route
                                      path="/dora"
                                      element={<DORA userData={user} />}
                                    />
                                    <Route
                                      path="/cra"
                                      element={<CRA userData={user} />}
                                    />
                                    <Route
                                      path="/euaiact"
                                      element={
                                        <EUAIActCompliance userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/cscrfbysebi"
                                      element={<CSCRF userData={user} />}
                                    />
                                    <Route
                                      path="/nationalcybersecuritybill"
                                      element={
                                        <NationalCyberSecurity userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/cybersecurityandresiliencebill"
                                      element={
                                        <CyberSecurityandResilience
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/govassureprogram"
                                      element={
                                        <GovAssureProgram userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/incidentreporting"
                                      element={
                                        <IncidentReporting userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/hipaa"
                                      element={<HIPAA userData={user} />}
                                    />
                                    <Route
                                      path="/circia"
                                      element={<CIRCIA userData={user} />}
                                    />
                                    <Route
                                      path="/siemintegration"
                                      element={
                                        <SiemIntegration userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/icfr"
                                      element={<ICFR userData={user} />}
                                    />
                                    <Route
                                      path="/soxcompliance"
                                      element={<SOXCompliance userData={user} />}
                                    />
                                    <Route
                                      path="/upcomingaiexecutiveorders"
                                      element={
                                        <UpcomingExecutiveOrdersonAIandCybersecurity
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/cissecurity"
                                      element={<CISSecurity userData={user} />}
                                    />
                                    <Route
                                      path="/organizational"
                                      element={<Organizational userData={user} />}
                                    />
                                    <Route
                                      path="/people"
                                      element={<People userData={user} />}
                                    />
                                    <Route
                                      path="/physical"
                                      element={<Physical userData={user} />}
                                    />
                                    <Route
                                      path="/technological"
                                      element={<Technological userData={user} />}
                                    />
                                    <Route
                                      path="/annexacontrolsoverview"
                                      element={
                                        <AnnexAControlsOverview userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/soc2"
                                      element={<SOC2 userData={user} />}
                                    />
                                    <Route
                                      path="/nistsp80053"
                                      element={<NISTSP80053 userData={user} />}
                                    />
                                    <Route
                                      path="/red"
                                      element={<RED userData={user} />}
                                    />
                                    <Route
                                      path="/pcidSScompliance"
                                      element={
                                        <PCIDSSCompliance userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/otiotsecurity"
                                      element={<OTIoTSecurity userData={user} />}
                                    />
                                    <Route
                                      path="/nistsp80063iam"
                                      element={<NISTSP80063IAM userData={user} />}
                                    />
                                    <Route
                                      path="/operationalresilience"
                                      element={
                                        <OperationalResilience userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/mitre"
                                      element={<MITRE userData={user} />}
                                    />
                                    <Route
                                      path="/cobit"
                                      element={<COBIT userData={user} />}
                                    />
                                    <Route
                                      path="/owasp"
                                      element={<OWASP userData={user} />}
                                    />

                                    {/* Oracle */}
                                    <Route
                                      path="/iamoracle"
                                      element={<IAMOracle userData={user} />}
                                    />
                                    <Route
                                      path="/consent-management"
                                      element={<ConsentManagementModule userData={user} />}
                                    />
                                    <Route
                                      path="/dataprotectionoracle"
                                      element={
                                        <DataProtectionOracle userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/detectionoracle"
                                      element={
                                        <DetectionOracle userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/incidentresponseoracle"
                                      element={
                                        <IncidentResponseOracle userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/infrastructureprotectionoracle"
                                      element={
                                        <InfrastructureProtectionOracle
                                          userData={user}
                                        />
                                      }
                                    />

                                    {/* Network */}
                                    <Route
                                      path="/networksecurity"
                                      element={
                                        <NetworkSecurity userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/privatecloudhypervisor"
                                      element={
                                        <PrivateCloudHypervisor userData={user} />
                                      }
                                    />

                                    {/* Vendors */}
                                    <Route
                                      path="/cisco"
                                      element={<Cisco userData={user} />}
                                    />
                                    <Route
                                      path="/checkpoint"
                                      element={<Checkpoint userData={user} />}
                                    />
                                    <Route
                                      path="/fortinet"
                                      element={<Fortinet userData={user} />}
                                    />
                                    <Route
                                      path="/paloalto"
                                      element={<PaloAlto userData={user} />}
                                    />
                                    <Route
                                      path="/juniper"
                                      element={<Juniper userData={user} />}
                                    />

                                    {/* Compliance */}
                                    <Route
                                      path="/third-partyinfrastructure"
                                      element={
                                        <ThirdPartyInfrastructure
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/regulatoryengagement"
                                      element={
                                        <RegulatoryEngagement userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/encryption&icoreadiness"
                                      element={
                                        <EncryptionICOReadiness userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/quantum-resilientsecurity"
                                      element={
                                        <QuantumResilientSecurity
                                          userData={user}
                                        />
                                      }
                                    />

                                    <Route path="/dast-scanner" element={<DastScanPage userData={user} />} />




                                    <Route
                                      path="/pecrcompliance"
                                      element={<PECRCompliance userData={user} />}
                                    />
                                    <Route
                                      path="/telecomsecurityact"
                                      element={
                                        <TelecomSecurityAct userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/ncsccaf"
                                      element={<NCSCCAF userData={user} />}
                                    />
                                    <Route
                                      path="/psn"
                                      element={<PSNCompliance userData={user} />}
                                    />
                                    <Route
                                      path="/cyberessential"
                                      element={
                                        <CyberEssentials userData={user} />
                                      }
                                    />
                                    <Route path="/ps21/3" element={<PS21 />} />

                                    {/* Duplicate block kept as-is */}
                                    <Route
                                      path="/Iam"
                                      element={<IAM userData={user} />}
                                    />
                                    <Route
                                      path="/overview"
                                      element={<Overview userData={user} />}
                                    />
                                    <Route
                                      path="/detection"
                                      element={<Detection userData={user} />}
                                    />
                                    <Route
                                      path="/infrastructure_protection"
                                      element={<Infrastructure userData={user} />}
                                    />
                                    <Route
                                      path="/dataprotection"
                                      element={<DataProtection userData={user} />}
                                    />
                                    <Route
                                      path="/inscidentresponseandautomation"
                                      element={
                                        <InscidentResponse userData={user} />
                                      }
                                    />

                                    {/* Azure */}
                                    <Route
                                      path="/iamazurecloudsecurity"
                                      element={<IAMAzure userData={user} />}
                                    />
                                    <Route
                                      path="/detectionazure"
                                      element={<DetectionAzure userData={user} />}
                                    />
                                    <Route
                                      path="/infrastructureprotectionazure"
                                      element={
                                        <InfrastructureProtectionAzure
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/dataprotectionazure"
                                      element={
                                        <DataProtectionAzure userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/aiazure"
                                      element={
                                        <IncidentResponseAzure userData={user} />
                                      }
                                    />

                                    {/* Google */}
                                    <Route
                                      path="/iamgoogle"
                                      element={<IAMGoogle userData={user} />}
                                    />
                                    <Route
                                      path="/detectiongoogle"
                                      element={
                                        <DetectionGoogle userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/infrastructureprotectiongoogle"
                                      element={
                                        <InfrastructureProtectiongoogle
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/dataProtectionGoogle"
                                      element={
                                        <DataProtectionGoogle userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/aiGoogle"
                                      element={
                                        <IRautomationGoogle userData={user} />
                                      }
                                    />

                                    {/* Others */}
                                    <Route
                                      path="/devsecops"
                                      element={<DevSecOps userData={user} />}
                                    />
                                    <Route
                                      path="/grouppolicies"
                                      element={<GroupPolicies userData={user} />}
                                    />
                                    <Route
                                      path="/hybridconnect"
                                      element={<HybridConnect userData={user} />}
                                    />
                                    <Route
                                      path="/iamandmfa"
                                      element={<IAMandMFA userData={user} />}
                                    />
                                    <Route
                                      path="/intunesuserenrollmentandmanagement"
                                      element={
                                        <InTunesUserEnrollmentAndManagement
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/onpremtocloudmigration"
                                      element={
                                        <OnPremToCloudMigration userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/sentinel"
                                      element={<Sentinel userData={user} />}
                                    />
                                    <Route
                                      path="/ssoandenterpriseapplications"
                                      element={
                                        <SSOAndEnterpriseApplications
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/useradministration"
                                      element={
                                        <UserAdministration userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/windowsuserbitlockerencryption"
                                      element={
                                        <WindowsUserBitlockerencryption
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/windowsuserfirewallmanagement"
                                      element={
                                        <WindowsUserFirewallManagement
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/windowsuserpatching"
                                      element={
                                        <WindowsUserPatching userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/wirelesssecurity"
                                      element={
                                        <WirelessSecurity userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/applicationdatabasesecurity"
                                      element={
                                        <ApplicationDatabaseSecurity
                                          userData={user}
                                        />
                                      }
                                    />
                                    <Route
                                      path="/genai"
                                      element={<GenAI userData={user} />}
                                    />
                                    <Route
                                      path="/blockchainsecurity"
                                      element={
                                        <BlockchainSecurity userData={user} />
                                      }
                                    />
                                    <Route
                                      path="/actionplan"
                                      element={<ActionPlan userData={user} />}
                                    />

                                    {/* ✅ IMPORTANT: fallback */}
                                    <Route
                                      path="*"
                                      element={<SecurityModel userData={user} />}
                                    />
                                  </>
                                ) : (
                                  <Route
                                    path="*"
                                    element={
                                      <div className="loading-screen">
                                        <img
                                          src={logoGif}
                                          alt="Loading..."
                                          className="logo-animation"
                                        />
                                      </div>
                                    }
                                  />

                                )}


                              </Routes>
                            </Suspense>
                          </>
                        )}
                      </Router>
                    </AccessGateWrapper>
                  </DomainUsersProvider>
                </RefreshProvider>
              </ISOProvider>
            </ScoreProvider>
          </FormProvider>
        </NotificationProvider>
      </AuthProvider>
    </>
  );
};
export default App;
